import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

class ApartmentSlider {
	constructor(rootElement) {
		this.rootElement = rootElement;
		this.sliderElement = rootElement.querySelector(".js-apartment-slider__slider");
		this.nextButtonElement = rootElement.querySelector(".js-apartment-slider__nav-arrow-next");
		this.prevButtonElement = rootElement.querySelector(".js-apartment-slider__nav-arrow-prev");
		this.containerElement = rootElement.querySelector(".container");
		this.instance = null;

		this.handleResize = this.onResize.bind(this);
	}

	init() {
		if (!this.sliderElement || !this.nextButtonElement || !this.prevButtonElement) {
			return;
		}

		this.instance = new Swiper(this.sliderElement, {
			modules: [Navigation],

			slidesPerView: 1.15,
			spaceBetween: 10,

			speed: 500,
			grabCursor: true,

			watchOverflow: true,

			updateOnWindowResize: true,
			observer: true,
			observeParents: true,

			breakpoints: {
				992: {
					slidesPerView: 2.5, 
					spaceBetween: 10,
				},
				1200: {
					slidesPerView: 3.1, 
					spaceBetween: 10,
				},


			},

			navigation: {
				nextEl: this.nextButtonElement,
				prevEl: this.prevButtonElement,
			},

			on: {
				init: (swiper) => {
					swiper.update();
					swiper.updateSize();
				},
			},
		});

		this.updateOnReady();
		window.addEventListener("resize", this.handleResize);
	}

	updateOnReady() {
		requestAnimationFrame(() => {
			this.updateOffsets();
			this.instance?.update();
		});
	}

	onResize() {
		this.updateOffsets();
		this.instance?.update();
	}

	getSliderOffset() {
		if (!this.containerElement) return 0;

		const rect = this.containerElement.getBoundingClientRect();
		const styles = window.getComputedStyle(this.containerElement);
		const paddingLeft = parseFloat(styles.paddingLeft || "0");

		return Math.max(0, rect.left + paddingLeft);
	}

	getSliderOffsetRight() {
		if (!this.containerElement) return 0;

		const rect = this.containerElement.getBoundingClientRect();
		const styles = window.getComputedStyle(this.containerElement);
		const paddingRight = parseFloat(styles.paddingRight || "0");

		const contentRight = rect.right - paddingRight;

		return Math.max(0, window.innerWidth - contentRight);
	}

	updateOffsets() {
		if (!this.instance) return;

		this.instance.params.slidesOffsetBefore = this.getSliderOffset();
		this.instance.params.slidesOffsetAfter = this.getSliderOffsetRight();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".js-apartment-slider").forEach((el) => {
		new ApartmentSlider(el).init();
	});
});